// src/ui/Layout.js
import React, { useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import '../css/Ui.css';

function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="d-flex">
      {/* 좌측 Sidebar */}
      <Sidebar collapsed={collapsed} />

      {/* Navbar + Content */}
      <div className="main-wrapper flex-grow-1 d-flex flex-column">
        <Navbar onToggle={() => setCollapsed(!collapsed)} />
        <main className="content">{children}</main>
      </div>
    </div>
  );
}

export default Layout;